import observable from '@riotjs/observable';

export const CONFIRM_OPEN = 'CONFIRM_OPEN';
export const CONFIRM_CLOSE = 'CONFIRM_CLOSE';
export const CONFIRM_OK = 'CONFIRM_OK';
export const CONFIRM_CANCEL = 'CONFIRM_CANCEL';
export const CONFIRM_EXT = 'CONFIRM_EXT';
export const CONFIRM_CLOSE_WITH_OK = 'CONFIRM_CLOSE_WITH_OK';
export const model = observable();

export const openConfirm = (message, ...ext) => {
  return new Promise((resolve) => {
    model.one(CONFIRM_OK, () => resolve(true));
    model.one(CONFIRM_CANCEL, () => resolve(false));
    model.one(CONFIRM_EXT, (data) => resolve(data));
    model.trigger(CONFIRM_OPEN, message, ...ext);
  });
};

export const closeConfirm = () => {
  model.trigger(CONFIRM_CLOSE);
};

export const closeConfirmWithOK = () => {
  model.trigger(CONFIRM_CLOSE_WITH_OK);
  // Jest やテスト環境から呼んだ場合、kf-confirm が mount されていない可能性が高いので、
  // 手動で CONFIRM_OK を出して Promise を resolve する（model.one なので複数回 trigger しても大丈夫）
  model.trigger(CONFIRM_OK);
};
